<template>
    <span  v-bind:style="{color: $store.state.siteData.legColors[index]}">
        <b-input plaintext style="width: 140px; border:1px solid gray; text-align: left; background-color: whitesmoke"
                 size="sm"
                 v-model.number="unitMove" 
                 v-bind:style="{color: $store.state.siteData.legColors[index]}">
        </b-input>
    </span>
</template>

<script>
    module.exports = {
        props: ['namespace', 'index'],
        computed: {
            unitMove: {
                get() {
                    return " unit move: $" + this.$store.state[this.namespace].unitMove[this.index];
                },
                set(unitMove) {
                    if (unitMove !== "") {
                        var newArray = this.$store.state[this.namespace].unitMove.slice(0);
                        newArray[this.index] = unitMove;
                        this.$store.commit(this.namespace + '/setUnitMove', newArray);
                        this.$store.commit(this.namespace + '/chartParameters/setPage', 1);
                    }
                }
            }
        }/*,
         methods: {
         tooltip: function () {
         return "unitMove_tooltip";
         }
         }*/
    }
</script>
